import { useEffect } from "react";
import { ConnectedProps, connect } from "react-redux";
import { actions, slotSelector } from "reducers/slots";
import { SlotsFilterType } from "reducers/types/slots";
import { AppDispatch, RootState } from "store";
import SlotsDetailFilter from "./SlotsDetailFilter";
import { SlotsDetailFilterContainerPropsType } from "./types";
import "./i18n";
import { SLOTS_SHIFTS } from "utils/constants";

const SlotsDetailFilterContainer = (
  props: SlotsDetailFilterContainerPropsType & ConnectorProps
) => {
  useEffect(() => {
    props.resetWorkzones();
    props.getSlots({ ...props.filters, ...props.filtersExtra });
    if (props.filters.region) {
      props.getWorkzones(props.actualRegion);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onUpdateWorkzones = (region: string) => {
    if (region && region !== props.actualRegion) {
      props.getWorkzones(region);
      props.setActualRegion(region);
    }
  };
  const search = (values: SlotsFilterType) => {
    props.setSlotsFilters(values);
    props.getSlots({ ...values, ...props.filtersExtra });
  };

  return (
    <SlotsDetailFilter
      id="slots-detail-filter"
      {...props}
      shifts={SLOTS_SHIFTS}
      onUpdateWorkzones={onUpdateWorkzones}
      onSubmit={search}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  workzones: slotSelector(state).workzones,
  actualRegion: slotSelector(state).actualRegion,
  filters: slotSelector(state).filters,
  fetchingWorkzones: slotSelector(state).fetchingWorkzones,
  filtersExtra: slotSelector(state).filtersExtra,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getWorkzones: (regionId: string) => {
    dispatch(actions.getWorkzonesFetch(regionId));
  },
  setActualRegion: (regionId: string) => {
    dispatch(actions.setActualRegion(regionId));
  },
  setSlotsFilters: (filters: SlotsFilterType) => {
    dispatch(actions.setSlotsFilters(filters));
  },
  getSlots: (params: SlotsFilterType) => {
    dispatch(actions.getSlotsRequest(params));
  },
  resetWorkzones: () => {
    dispatch(actions.resetWorkzones());
  },
  setCollapseTable: (collapse: boolean) => {
    dispatch(actions.setCollapseTable(collapse));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(SlotsDetailFilterContainer);
